import { DateUtil } from '@src/packages/utils/dates';

/** Today's calendar date (`YYYY-MM-DD`) in the app default timezone. */
export const getMatrixTodayIsoDate = (nowMs: number = Date.now()): string =>
  DateUtil.toDateString(nowMs, 'YYYY-MM-DD', DateUtil.getDefaultTimeZone());

/**
 * True when `isoDate` (`YYYY-MM-DD`) is strictly after today in the app default
 * timezone. Future days have no attendance marking yet — selection bar only.
 */
export const isFutureMatrixCalendarDate = (
  isoDate: string,
  nowMs: number = Date.now(),
): boolean => {
  if (!isoDate) return false;
  return isoDate > getMatrixTodayIsoDate(nowMs);
};
